import { TrackingFunctions } from "../../../../bower_components/tracking-library/src/typescript/tracking-service/tracking-functions"
import { getSingletonInstance } from "./singleton-cache"

export default class TrackingService {
    public static trackEvent(eventName: string, details: any[]) {
        return getSingletonInstance(new TrackingFunctions())
            .trackCurrent(eventName, details)
    }
}